import DeleteConformationDialog from './DeleteConfirmationDialog.view';

export default DeleteConformationDialog;
